export const reservedKeywords = [
    'dictionary',
    'user_wallet',
    'edge_def',
    'STRING',
    'INTEGER',
    'LONG',
    'BOOLEAN',
    'DECIMAL',
    'DATE',
    'DATETIME',
    'FINGERPRINT',
    'ENUM',
    'NODE',
    'PRIMARY',
    'UNIQUE',
    'NORMAL',
    'FULLTEXT',
    'KEEP',
    'REMOVE',
    'ERROR',
    'AGGREGATE',
    'LET',
    'KEEP',
    'WITH',
    'COUNT',
    'AND',
    'OR',
    'ALL',
    'NONE',
    'ANY',
    'AS',
    'ASC',
    'DESC',
    'DISTINCT',
    'FROM',
    'GROUP',
    'IN',
    'NOT IN',
    'LIMIT',
    'NOT',
    'NULL',
    'SELECT',
    'SORT',
    'WHERE',
    'INNER',
    'JOIN',
    'INTO',
    'LIKE',
    'NOT LIKE',
    'OUTER',
    'FALSE',
    'TRUE',
    'FULLTEXT',
    'SEARCH',
    'FILTER',
    'SHORTEST_PATH',
    'INBOUND',
    'OUTBOUND',
    'UPSERT',
    'REPLACE',
    'UPDATE',
    'COLLECT',
    'GRAPH',
    'RETURN',
    'VERTEX',
    'EDGE',
    'PATH',
];

export const regExIdentifiers = {
    name: /^[a-zA-Z]\w{0,63}$/,
    numbers: /^-?\d+$/,
    decimals: /^-?(0|[1-9]\d*)(\.\d+)?$/,
    precision: /^(1[0-5]?|[1-9])$/,
    maxNumberOfRows: /^(?:$|(?:\d{1,4}|10000))$/,
    nonRequiredNumbers: /^(?:-?\d+)?$/,
};

export const validationMessages = {
    required: 'Please enter Name.',
    invalidName:
        'Field should only contain alphabets or contain _ and length should be 1-64 characters.',
    reservedWord: 'Reserved keywords are not accepted.',
    invalidNumber: 'Please enter a valid numeric value',
    invalidDecimal: 'Please enter valid numeric and decimal values only',
    precision: 'Please choose a value between 1 and 15.',
    maxNumberOfRows: 'Please choose a value between 0 and 10000.',
};
